import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FaSearchMinus, FaHome, FaBriefcase } from 'react-icons/fa';

const NotFound = () => (
  <>
  <Helmet>
    <title>Page Not Found | HireMeJA</title>
    <meta name="description" content="The page you're looking for doesn't exist. Browse jobs in Jamaica or return to the HireMeJA homepage." />
    <meta name="robots" content="noindex, nofollow" />
  </Helmet>
  <div className="min-h-[80vh] flex items-center justify-center px-4 bg-gray-50">
    <div className="text-center max-w-md">
      <div className="flex justify-center mb-4">
        <div className="bg-blue-950 text-[#cddd3a] rounded-full w-24 h-24 flex items-center justify-center">
          <FaSearchMinus size={44} />
        </div>
      </div>

      <p className="text-7xl font-extrabold text-[#cddd3a] leading-none mb-2">404</p>
      <h1 className="text-2xl font-bold text-blue-950 mb-3">Page Not Found</h1>
      <p className="text-gray-500 text-sm leading-relaxed mb-8">
        The page you're looking for doesn't exist or may have been moved.
        Let's get you back on track.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 bg-blue-950 text-white px-6 py-3 rounded-md text-sm font-semibold hover:bg-[#cddd3a] hover:text-blue-950 transition-colors"
        >
          <FaHome size={14} /> Go Home
        </Link>
        <Link
          to="/jobs"
          className="inline-flex items-center justify-center gap-2 border-2 border-blue-950 text-blue-950 px-6 py-3 rounded-md text-sm font-semibold hover:bg-blue-950 hover:text-white transition-colors"
        >
          <FaBriefcase size={14} /> Browse Jobs
        </Link>
      </div>
    </div>
  </div>
  </>
);

export default NotFound;
